/* eslint-disable */
export default {
  doNotCall: '발신 금지',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
